import React from 'react'
import Head from 'react-helmet'

import Hero from './Hero'
import Description from './Description'
import Features from './Features'
import CallToAction from '../components/CallToAction'

const IgcseComputing = () => {
  return (
    <>
      <Head>
        <title>IGCSE Computing</title>
      </Head>
      <Hero />
      <Description />
      <Features />
      <CallToAction />
    </>
  )
}

export default IgcseComputing
